import React from 'react';
import { BarChart3, TrendingUp, BookOpen, ShieldCheck } from 'lucide-react';
export type Page = 'scorecard' | 'career' | 'points' | 'admin';
interface PageNavProps {
  page: Page;
  onChange: (page: Page) => void;
}
export function PageNav({
  page,
  onChange
}: PageNavProps) {
  const tabs: {
    id: Page;
    label: string;
    icon: React.ReactNode;
  }[] = [{
    id: 'scorecard',
    label: 'Scorecard',
    icon: <BarChart3 className="w-4 h-4" data-id="element-611" data-mp="2ga8kn91lz5sl" />
  }, {
    id: 'career',
    label: 'Career Progression',
    icon: <TrendingUp className="w-4 h-4" data-id="element-612" data-mp="2bgxezb8j8v29" />
  }, {
    id: 'points',
    label: 'Point System',
    icon: <BookOpen className="w-4 h-4" data-id="element-613" data-mp="26jngz772vb2t" />
  }, {
    id: 'admin',
    label: 'Admin',
    icon: <ShieldCheck className="w-4 h-4" data-id="element-614" data-mp="22jn2xnnw51wa" />
  }];
  return <nav className="bg-white border-b border-gray-200 px-4 sm:px-6" aria-label="Primary" data-id="element-615" data-mp="1xiz1s95y74oc">
      <div className="max-w-[1600px] mx-auto flex gap-1" data-id="element-616" data-mp="1sknt41re307p">
        {tabs.map(tab => {
        const active = page === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} aria-current={active ? 'page' : undefined} className={`relative flex items-center gap-2 px-4 py-3 text-sm font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-t-md ${active ? 'text-[#0a1e5e]' : 'text-gray-500 hover:text-[#0a1e5e]'}`} data-id="element-617" data-mp="3uxz4f2060ts7">
              {tab.icon}
              <span data-id="element-618" data-mp="mk9yfny8nfke">{tab.label}</span>
              {active && <span className="absolute left-2 right-2 -bottom-px h-0.5 bg-[#0a1e5e] rounded-full" data-id="element-619" data-mp="mhnojhnvknz0" />}
            </button>;
      })}
      </div>
    </nav>;
}